<template>
  <nx-dashboard-card
    class="nx-dashboard-activity-card"
    :title="$t('message.dashboard.activity.title')"
    hide-actions
  >
    <template v-slot:body>
      <v-layout
        v-if="!loading"
        class="nx-activity-list row wrap"
      >
        <nx-dashboard-activity-item
          v-for="item in paginatedItems"
          :id="item.id"
          :key="item.uuid"
          :entity="item.entity"
          :title="item.title"
        />
      </v-layout>
      <div
        v-else
        class="nx-activity-list px-4"
      >
        <nx-skeleton-loader
          v-for="index in Array(limit)"
          :key="index"
          class="nx-list-item"
          width="100%"
          :height="40"
          animation="fade"
        />
      </div>
    </template>
    <template v-slot:footer>
      <nx-dashboard-card-footer
        v-if="hasMorePages"
        :title="$t('message.common.viewMore')"
        @click="paginate"
      />
    </template>
  </nx-dashboard-card>
</template>

<script>
import DashboardCard from '@/modules/dashboard/mixins/dashboard-card';
import NxDashboardCard from '@/modules/dashboard/components/DashboardCard';
import NxDashboardCardFooter from '@/modules/dashboard/components/DashboardCardFooter';
import NxSkeletonLoader from '@/components/skeleton/SkeletonLoader';
import NxDashboardActivityItem from '@/modules/dashboard/components/DashboardActivityItem';
import uniqWith from 'lodash/uniqWith';
import { mapState } from 'vuex';

export default {
  name: 'NxDashboardActivityCard',
  components: {
    NxDashboardActivityItem,
    NxSkeletonLoader,
    NxDashboardCardFooter,
    NxDashboardCard,
  },
  mixins: [DashboardCard],
  data() {
    return {
      page: 1,
      limit: 10,
    };
  },
  computed: {
    ...mapState('activity', ['feed']),
    loading() {
      return this.feed === undefined;
    },
    filteredItems() {
      if (!this.feed) {
        return [];
      }
      // Sort activity feed by desc date
      const sortedFeed = [...this.feed].sort((a, b) => new Date(b.date) - new Date(a.date));
      // Filter duplicates from activity feed
      return uniqWith(sortedFeed, (item1, item2) => item1.entity === item2.entity && item1.id === item2.id);
    },
    paginatedItems() {
      const offset = this.page * this.limit;
      return this.filteredItems.slice(0, Math.min(offset, this.filteredItems.length));
    },
    hasMorePages() {
      return this.paginatedItems.length < this.filteredItems.length;
    },
  },
  methods: {
    paginate() {
      this.page += 1;
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

.nx-dashboard-activity-card {
  .nx-activity-list {
    margin: 0 -16px;

    .nx-activity-item {
      height: 40px;
      width: 100%;
      border-bottom: 1px solid $nx-neutral-100;

      .v-list__tile {
        height: 40px;
        padding: 0 8px;
      }

      .v-list__tile__avatar {
        min-width: 48px;
      }

      &-icon {
        color: $nx-neutral-200;
        font-size: 24px;
      }

      &-link {
        text-decoration: none;
        color: $nx-neutral-800;
        font-size: 15px;
        font-weight: 400;
        line-height: 130%;
      }

      &-type {
        color: $nx-neutral-900;
        font-weight: 600;
        font-size: 14px;
        line-height: 130%;
      }

      &-title {
        color: $nx-neutral-700;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
      }
    }
  }
}
</style>
